import React from 'react'
import { ButtonGroup } from 'react-bootstrap'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { AssetTypeEnum } from '@ztechapps/common.contract'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import { NullComponent } from '@ztechapps/webui.util'
import { DataTool } from '../DataTool'
import { GridListToggle } from '../GridListToggle'
import { useAssetPageContext } from './Context'
import { UploadViaUppy } from './UploadViaUppy'

const fieldsConfig: ListFieldConfig = {
  title: { name: 'title', displayName: 'Title', defaultOnSearch: true },
  subtitle: { name: 'subtitle', displayName: 'Subtitle' },
  type: {
    name: 'type',
    displayName: 'Type',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: Object.values(AssetTypeEnum),
    },
  },
}

const OtherButtons = () => {
  const { viewMode, setViewMode } = useAssetPageContext()

  return (
    <ButtonGroup>
      <UploadViaUppy />
      <GridListToggle viewMode={viewMode} setViewMode={setViewMode} />
    </ButtonGroup>
  )
}

export const DataAction = () => {
  const { localListAction } = useAssetPageContext()

  return (
    <div className="d-flex justify-content-end">
      <DataTool
        {...localListAction}
        fieldsConfig={fieldsConfig}
        filterCategory="filter_asset_container"
        components={{ other: OtherButtons, sort: NullComponent, refresh: NullComponent }}
        searchPlaceHolder="Search assets."
      />
    </div>
  )
}
